module.exports = "/assets/34ff3d3841fc8f573a947460c675d666.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/9J.png
// module id = 2292
// module chunks = 0